import { render, staticRenderFns } from "./MealsTypeFloatBtns.vue?vue&type=template&id=95bc7464&"
import script from "./MealsTypeFloatBtns.vue?vue&type=script&lang=js&"
export * from "./MealsTypeFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports